import Subscription from "../subscription/subscription";
import styles from "./article_header.module.scss"
function ArticleHeader() {
    return (
        <header className={styles.header}>
            <Subscription />
        </header>
    );
}

export default ArticleHeader;